import { styled } from "twin.macro"

export const BlurBG = styled.div`
  background: linear-gradient(
    91.29deg,
    rgba(79, 79, 79, 0.7056) 0%,
    rgba(79, 79, 79, 0.2016) 100%
  );
  box-shadow: 8px 8px 25px rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(24px);
`
